import { render, staticRenderFns } from "./AttachmentListView.vue?vue&type=template&id=1cde2bfc&scoped=true&"
import script from "./AttachmentListView.vue?vue&type=script&lang=js&"
export * from "./AttachmentListView.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentListView.vue?vue&type=style&index=0&id=1cde2bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde2bfc",
  null
  
)

export default component.exports